import { Collapse, Row, Space, Title, Text, Toggle, colors } from 'common-components';
import { Dispatch, ReactNode, SetStateAction } from 'react';

type CollapseWithPillPropsType = {
  panels: {
    title: string
    content: ReactNode
    subtitle?: string
    isOpen?: boolean
    setIsOpen?: Dispatch<SetStateAction<boolean>>
    withPill?: boolean
    titleLevel?: 1 | 2 | 3 | 4 | 5 | 6
    modifEnabled?: boolean | null
  }[]
};

const CollapseWithPill = ({ panels }: CollapseWithPillPropsType) => {
  const activeKeys = panels.filter((panel) => panel.isOpen).map((panel) => panel.title);

  return (
    <Collapse
      activeKey={activeKeys}
      style={{ width: '100%', borderRadius: 12, overflow: 'hidden' }}
      items={panels.map(
        ({
          title,
          content,
          subtitle,
          isOpen,
          setIsOpen,
          modifEnabled = true,
          withPill = true,
          titleLevel = 5,
        }) => ({
          key: title,
          label: (
            <Row
              style={{
                padding: `${titleLevel === 6 ? 16 : 24}px 24px ${isOpen ? 8 : titleLevel === 6 ? 16 : 24}px`,
              }}
              justify="space-between"
              onClick={(e) => e.stopPropagation()}
            >
              <Space orientation="vertical">
                {titleLevel === 6 ? (
                  <Text size="sm" color={colors.gray900} style={{ fontWeight: 500 }}>
                    {title}
                  </Text>
                ) : (
                  <Title level={titleLevel} style={{ color: colors.gray900 }}>
                    {title}
                  </Title>
                )}
                {subtitle && <Text size="sm">{subtitle}</Text>}
              </Space>
              {withPill && (
                <Toggle
                  checked={isOpen}
                  onChange={(checked) => setIsOpen(checked)}
                  disabled={!modifEnabled}
                />
              )}
            </Row>
          ),
          children: content,
          showArrow: false,
          style: { borderTop: 'none' },
        }),
      )}
    />
  );
};

export default CollapseWithPill;
